import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";

const ReadExcel = React.memo(({ filePath, onDataLoad }) => {
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchExcelData = async () => {
      try {
        // Fetching file
        const response = await fetch(filePath);
        const arrayBuffer = await response.arrayBuffer();

        // Reading file with multiple data sheets
        const workbook = XLSX.read(arrayBuffer, { type: "array" });
        const parsedData = {};
        
        workbook.SheetNames.forEach((sheetName) => { // Get sheet names
          const sheet = workbook.Sheets[sheetName]; // Get the current sheet
          parsedData[sheetName] = JSON.parse( // Parse the current sheet into an object to work with
            JSON.stringify(XLSX.utils.sheet_to_json(sheet)) // Convert the current sheet to JSON
          );
        });

        // Send data back to the component
        if (isMounted) onDataLoad(parsedData);
      } catch (err) {
        console.error("Error reading the Excel file:", err);
        if (isMounted) setError("Failed to load the Excel file.");
      }
    };

    fetchExcelData();
    
    return () => {
      isMounted = false; // Cleanup function to prevent memory leaks
    };
  }, [onDataLoad, filePath]);

  return error ? <p style={{ color: "red" }}>{error}</p> : null;
});

export default ReadExcel;
